import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './js/table2excel'


const app = createApp(App)
app.use(router).mount('#app');

